import { AuthPageLayout } from "./AuthPageLayout";
import { LoadingButton } from "./LoadingButton";
import { CodeInputField } from "./CodeInputField";

/**
 * MFA コード入力 UI
 */
export const MFACodeUI: React.FC<{
  challengeType: string;
  loading: boolean;
  error: string | null;
  recoverySuggestion: string | null;
  mfaCode: string;
  onMfaCodeChange: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  onCancel: () => void;
}> = ({
  challengeType,
  loading,
  error,
  recoverySuggestion,
  mfaCode,
  onMfaCodeChange,
  onSubmit,
  onCancel,
}) => {
  const isTOTP = challengeType === "CONFIRM_SIGN_IN_WITH_TOTP_CODE";
  const isSMS = challengeType === "CONFIRM_SIGN_IN_WITH_SMS_CODE";

  return (
    <AuthPageLayout>
      {/* タイトル */}
      <h2 className="text-3xl font-bold text-center text-neutral-900 mb-4">
        {isTOTP && "認証コードの入力"}
        {isSMS && "SMS認証コードの入力"}
      </h2>
      <p className="text-center text-neutral-600 mb-8">
        {isTOTP && "認証アプリに表示されている6桁のコードを入力してください。"}
        {isSMS && "SMSで送信された6桁のコードを入力してください。"}
      </p>

      {/* フォーム */}
      <form onSubmit={onSubmit} className="space-y-6">
        {/* MFAコード */}
        <div>
          <label className="block text-sm font-medium text-neutral-700 mb-2">
            認証コード
          </label>
          <CodeInputField
            value={mfaCode}
            onChange={onMfaCodeChange}
            disabled={loading}
            placeholder="000000"
          />
        </div>

        {/* エラーメッセージ */}
        {error && <div className="text-sm text-red-600">{error}</div>}
        {recoverySuggestion && (
          <div className="text-sm text-neutral-700">{recoverySuggestion}</div>
        )}

        {/* ボタン */}
        <div className="space-y-3">
          <LoadingButton loading={loading} loadingMessage="確認中..." label="確認する" />

          <button
            type="button"
            onClick={onCancel}
            className="w-full bg-gray-500 hover:bg-gray-600 text-white py-4 rounded-2xl text-xl font-bold transition-colors"
            disabled={loading}
          >
            キャンセル
          </button>
        </div>
      </form>
    </AuthPageLayout>
  );
};
